import { ControlValueAccessor } from '@angular/forms';

export class ValueAccessorBase<T> implements ControlValueAccessor {
    private innerValue: T;

    private changed = new Array<(value: T) => void>();
    private touched = new Array<() => void>();

    protected innerChanged(value: T) {}

    get value(): T {
        return this.innerValue;
    }

    set value(value: T) {
        if (this.innerValue !== value) {
            this.writeValue(value);
            this.signalChanged();
        }
    }

    signalChanged(): void {
        this.changed.forEach(f => f(this.innerValue));
    }

    touch(): void {
        this.touched.forEach(f => f());
    }

    writeValue(value: T): void {
        this.innerValue = value;
        this.innerChanged(value);
    }

    registerOnChange(fn: (value: T) => void): void {
        this.changed.push(fn);
    }

    registerOnTouched(fn: () => void): void {
        this.touched.push(fn);
    }
}
